import type { PlanStatus } from './subscription.types';

export const STATUS_LABEL: Record<PlanStatus, string> = {
  active: 'Active',
  trial: 'Trial',
  past_due: 'Past due',
  lifetime: 'Lifetime',
};
